import {HeatingModel} from "../collected-data-model";

export class HeatingInformationModel {
  withHeating: boolean;
  heatingRoomLength: number;
  heatingRoomWidth: number;
  heatingShutdownPossible: boolean;
  heatingSpaceAvailable: boolean;
  heatingControlType: string;
  heatingControlImage: string;
  heatings: HeatingModel[];

  constructor() {
    this.withHeating = true;
    this.heatings = [new HeatingModel()];
  }

  public static initialize(model: HeatingInformationModel): void {
    if (model.withHeating === null || model.withHeating === undefined) {
      model.withHeating = true;
    }
    if (!model.heatings) {
      model.heatings = [new HeatingModel()];
    }
  }
}
